import { bootstrapStandaloneHelpAgent } from '@/standalone/runtime';

import { registerHelpAgentWidget } from './lib';
import { HelpAgentApp } from './components/help-agent-app';

registerHelpAgentWidget();

async function bootstrapStandalone(): Promise<void> {
  await customElements.whenDefined('help-agent-app');

  const app = document.querySelector('help-agent-app') as HelpAgentApp | null;
  if (!app) {
    return;
  }

  bootstrapStandaloneHelpAgent(app);
}

void bootstrapStandalone();
